import { render, staticRenderFns } from "./HarvestsCalendar.vue?vue&type=template&id=0c45b481"
import script from "./HarvestsCalendar.vue?vue&type=script&lang=ts"
export * from "./HarvestsCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports